import {IntegrationPartner} from 'src/openapi/admin/models/IntegrationPartner';

export const INPUT_WIDTH = 210;

export const NAMES = {
    costPerCredit: 'costPerCredit',
    overageCost: 'overageCost',
    initialPackage: 'initialPackage',
};

export const INTEGRATION_PARTNERS: Record<IntegrationPartner, string> = {
    [IntegrationPartner.SANDBOX]: 'Sandbox',
    [IntegrationPartner.FOUR_DEGREES]: '4Degrees',
    [IntegrationPartner.SINGLETRACK]: 'Singletrack',
    [IntegrationPartner.MADE_MARKET]: 'MadeMarket',
    [IntegrationPartner.DEAL_FABRIC]: 'DealFabric',
    [IntegrationPartner.NUCLA]: 'Nucla',
    [IntegrationPartner.DYNAMO]: 'Dynamo',
    [IntegrationPartner.BIPSYNC]: 'Bipsync',
    [IntegrationPartner.MIDAXO]: 'Midaxo',
    [IntegrationPartner.SMART_MERGER]: 'Smart Merger',
    [IntegrationPartner.DEAL_ROOM]: 'DealRoom',
};
